import React, { useState, useEffect, useRef, useContext } from "react";
import { Icon } from "@iconify/react";
import { useHistory, useLocation } from "react-router-dom";
import { ASSETS_URL, store } from "../../../Store";

import { useAccessibility } from "../../../../hooks/useAccessibility";
import { useGeneralHeaderDropdown } from "../../../../hooks/header/useGeneralHeaderDropdown";

import { DropdownMiCuenta } from "./DropdownMiCuenta";
import { DropdownComunidad } from "../../public-header/components/DropdownComunidad";
import { NotificationButton } from "../../components/notification-button";
import { LangButton } from "../../../language/lang-button";
import useIsMobile from "../../../../js/utilities/useIsMobile";
import { SearchBooksButton } from "./search-books-button";

/**
 * Componente con las opciones del header general
 * @param {object} textosInterfaz - contiene los textos de interfaz
 * @returns {JSX.Element} NavbarNav
 */
export const NavbarNav = ({ textosInterfaz }) => {

    const globalState = useContext(store);
    const { state } = globalState;
    const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";

    const [openDropdownCommunity, setOpenDropdownCommunity] = useState(false);
    const comunidadRef = useRef(null);

    const accessibility = useAccessibility();
    const accessibilityButtonRef = useRef(null);

    const showADropdown = useGeneralHeaderDropdown();
    const visible = showADropdown?.state?.visible;
    const dropdownButtonRef = useRef(null);
    const dropdown = useRef(null);

    const location = useLocation();
    const isMobile = useIsMobile();
    const isPersonalAccount = state?.isPersonalAccount;
    const accountLabel = !isPersonalAccount ? `${textosInterfaz?.mi_cuenta || "Mi cuenta"}` : `${textosInterfaz?.mi_perfil || "Mi perfil"}`;
    
const history= useHistory();

    /*Asigna el botón que abre el dropdown del header general */
    useEffect(() => {
        if (dropdownButtonRef.current && !isMobile) {
            globalState.dispatch({
                type: "CHANGE",
                path: "generalHeaderDropdown.triggerButtonRef",
                value: dropdownButtonRef,
            });
        }
    }, [dropdownButtonRef.current]);

    /*Asigna el botón que abre las opciones de accesibilidad */
    useEffect(() => {
        if (accessibilityButtonRef.current) {
            globalState.dispatch({
                type: "CHANGE",
                path: "accessibility.triggerButton",
                value: accessibilityButtonRef,
            });
        }
    }, [accessibilityButtonRef]);

    /*cierra el dropdown al hacer scroll al inicio de la página */
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY >= 1 && window.scrollY < 10) {
                showADropdown.setVisible(false);
                setOpenDropdownCommunity(false);
            }
        });
    }, [accessibility.state.visible])


    /**Función que permite cerrar el dropdown Comunidad dando click fuera de él*/
    useEffect(() => {
        if (comunidadRef.current) {
            let handlerComunidad = (e) => {
                if ( !comunidadRef.current.contains(e.target)) {
                    setOpenDropdownCommunity(false)
                }
            }
            document.addEventListener("mousedown", handlerComunidad, true);
            return () => {
                document.removeEventListener("mousedown", handlerComunidad, true)
            }
        }
    }, [comunidadRef])

    return (
        <ul className="option-nav d-flex justify-content-end aling-items-center"  role="list">
            <li>
                <SearchBooksButton />
            </li>

            <li
                ref={comunidadRef}
                className={`relative`}
            >
                <button
                    className={`focusable-red d-flex justify-content-center align-items-center
                        ${openDropdownCommunity && "openMode"} ${location.pathname === '/club-makemake' || location.pathname === '/blog' || location.pathname === '/centro-de-recursos' ? "btn-header-general activeMode" : "btn-header-general"}`
                    }
                    onClick={() => {
                        history.push('/club-makemake')
                        setOpenDropdownCommunity(!openDropdownCommunity);
                    }}
                    aria-label={textosInterfaz?.button_community_description || "Abrir la lista desplegable de páginas de comunidad seleccionables"}
                >
                    {textosInterfaz?.comunidad || 'Comunidad'}
                    <i className={`fas fa-chevron-down fa-sm ml-2 arrow d-none d-lg-block ${openDropdownCommunity && "active-arrow"}`} aria-hidden={true}></i>
                </button>

                <div ref={dropdown} className={`dropdownMenu dropDownComunidad ${openDropdownCommunity ? 'activeMode' : 'inactiveMode'} `}>
                    <DropdownComunidad
                        setOpenDropdown={setOpenDropdownCommunity}
                        openDropdown={openDropdownCommunity}
                        textosInterfaz={textosInterfaz}
                    />
                </div>
            </li>

            <li className="relative">
                <div className="wrapper-comunidad">
                    <button
                        ref={dropdownButtonRef}
                        className={`focusable-red d-flex justify-content-center align-items-center 
                        ${visible && 'openMode'} ${location.pathname.includes('/ayuda') || location.pathname.includes('/mi-panel') || location.pathname === '/descargados' || location.pathname === '/favoritos' ? "btn-header-general activeMode" : "btn-header-general"}`
                        }
                        onClick={() => {
                            setOpenDropdownCommunity(false);
                            showADropdown.setVisible(!showADropdown?.state?.visible);
                        }}
                        aria-label={textosInterfaz?.button_account_description ||  "Abrir la lista desplegable de páginas pertenecientes a mi cuenta"}
                    >
                        <div
                            className="mr-1 btn-avatar"
                            style={
                                { backgroundImage: `url('${isLogged ? `${ASSETS_URL}${state.datosHeader?.avatar}` : '/img/profile.png'}')` }
                            }
                        ></div>
                        <span className="una-linea-texto">{accountLabel}</span>
                        <i className={`fas fa-chevron-down fa-sm ml-2 arrow d-none d-lg-block ${visible && "active-arrow"}`} aria-hidden={true}></i>
                    </button>
                </div>
                <DropdownMiCuenta textosInterfaz={textosInterfaz} />
            </li>

            <li className={"ml-2"}>
                <button
                    ref={accessibilityButtonRef}
                    aria-expanded={accessibility.state.visible}
                    aria-label={textosInterfaz?.button_accesibility_description}
                    className={`focusable-red ${accessibility.state.visible ? 'icon-button activeMode' : ' icon-button'} `}
                    onClick={() => { accessibility.setVisible(!accessibility?.state?.visible) }}
                >
                    <Icon
                        icon="la:universal-access"
                        width="30" height="30"
                    />
                </button>
            </li>

            <NotificationButton />
            
            <li>
                <LangButton />
            </li>

        </ul>
    )
}